// Global, environment-agnostic debug switch (single source of truth)
// Flip this to true to enable debug across the entire app.
// No URL params. No env coupling.
export const DEBUG_ENABLED: boolean = false;

export function isDebugEnabled(): boolean {
  return DEBUG_ENABLED;
}

// Backward-compat stubs (no-ops) in case any code still calls these
export function initDebugFromUrl(): void { /* no-op */ }
export function setDebugEnabled(_enabled: boolean): void { /* no-op */ }
